import * as yup from "yup";
import { ReactSelectOption } from "../../models/generic";
import { FormValidationModel } from "../../models/validation";
import { ReactSelectOptionSchema } from "../generic";
import "../../utils/YupHelper";

export interface FinancialDisclosureData {
    commercialInterests: CommercialInterestData[];
    name: string;
    noCommercialInterests: boolean;
    userAttests: boolean;
}

export class FinancialDisclosure implements FormValidationModel<FinancialDisclosureData> {
    public data: FinancialDisclosureData;
    public rules: yup.Schema<FinancialDisclosureData>;

    public constructor() {
        this.data = {
            commercialInterests: [{... DefaultCommercialInterest}],
            name: "",
            noCommercialInterests: false,
            userAttests: false,
        };
        this.rules = yup.object<FinancialDisclosureData>().shape({
            commercialInterests: yup.array().of(CommercialInterestSchema).label("Commercial interests"),
            name: yup.string().required().label("Your name").max(250),
            noCommercialInterests: yup.bool().label("Commercial interests"),
            userAttests: yup.bool().label("Agreement").oneOf([true], "You must attest that the information provided above is accurate and complete"),
        });
    }
}

export interface CommercialInterestData {
    company: ReactSelectOption | null;
    compensations: ReactSelectOption[];
    id: number;
    index: number;
    isDelete: boolean;
    isSpouse: boolean;
    isVoid: boolean;
    relationships: ReactSelectOption[];
}

export const CommercialInterestSchema = yup.object<CommercialInterestData>().shape({
    company: ReactSelectOptionSchema.label("Company").when(["isDelete", "isVoid"], (isDelete: boolean, isVoid: boolean) => {
        const schema = ReactSelectOptionSchema.label("Company");
        return isDelete || isVoid
            ? schema
            : (schema as any).requiredReactSelect("$label is required");
    }),
    compensations: yup.array().of(ReactSelectOptionSchema).label("Nature of compensation").when(["isDelete", "isVoid"], (isDelete: boolean, isVoid: boolean) => {
        const schema = yup.array().of(ReactSelectOptionSchema).label("Nature of compensation");
        return isDelete || isVoid
            ? schema
            : schema.min(1, "Please select at least one type of compensation");
    }),
    id: yup.number().label("Commercial interest ID").required().min(0, "Invalid $label"),
    index: yup.number(),
    isDelete: yup.bool(),
    isSpouse: yup.bool(),
    relationships: yup.array().of(ReactSelectOptionSchema).label("Type of relationship").when(["isDelete", "isVoid"], (isDelete: boolean, isVoid: boolean) => {
        const schema = yup.array().of(ReactSelectOptionSchema).label("Type of relationship");
        return isDelete || isVoid
            ? schema
            : schema.min(1, "Please select at least one type of relationship");
    }),
    isVoid: yup.bool(),
});

export const DefaultCommercialInterest: CommercialInterestData = {
    company: { label: "", value: "" },
    compensations: [],
    id: 0,
    index: 0,
    isDelete: false,
    isSpouse: false,
    relationships: [],
    isVoid: false,
};



// WEBPACK FOOTER //
// ./src/forms/financialDisclosure/FinancialDisclosure.ts